import { FC } from 'react';
import { Info } from 'lucide-react';

interface Props {
  title: string;
  description: string;
}

const AlreadyPaidScreen: FC<Props> = ({ title, description }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="mb-6 flex size-20 items-center justify-center rounded-full bg-blue-100">
        <Info className="size-10 text-blue-600" />
      </div>
      <h1 className="text-2xl font-bold mb-2">{title}</h1>
      <p className="text-muted-foreground max-w-sm">{description}</p>
    </div>
  );
};

export default AlreadyPaidScreen;
